import { supabase } from '../lib/supabase';

export async function uploadImage(file, fileName) {
  const { data, error } = await supabase.storage
    .from('product-images')
    .upload(`settings/${fileName}`, file);
  
  if (error) throw error;
  
  const { data: { publicUrl } } = supabase.storage
    .from('product-images')
    .getPublicUrl(`settings/${fileName}`);
  
  return publicUrl;
}

export async function getSettings() {
  const { data, error } = await supabase
    .from('settings')
    .select('*');
  if (error) throw error;
  
  const settings = {};
  (data || []).forEach(item => {
    settings[item.key] = item.value.value || item.value;
  });
  return settings;
}

export async function updateSetting(key, value) {
  const { data, error } = await supabase
    .from('settings')
    .upsert({ key, value: { value } }, { onConflict: 'key' })
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function getHeroSlides() {
  const { data, error } = await supabase
    .from('hero_slides')
    .select('*')
    .eq('is_active', true)
    .order('order_index', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function getAllHeroSlides() {
  const { data, error } = await supabase
    .from('hero_slides')
    .select('*')
    .order('order_index', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function createHeroSlide(slide) {
  const { data, error } = await supabase
    .from('hero_slides')
    .insert(slide)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateHeroSlide(id, slide) {
  const { data, error } = await supabase
    .from('hero_slides')
    .update(slide)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteHeroSlide(id) {
  const { data, error } = await supabase
    .from('hero_slides')
    .delete()
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

// Category management functions
export async function getCategories() {
  try {
    const settingsData = await getSettings();
    if (settingsData.categories && Array.isArray(settingsData.categories)) {
      return settingsData.categories;
    }
    // If categories key exists but is not an array, try to parse it
    if (settingsData.categories) {
      console.warn('Categories data is not an array:', settingsData.categories);
    }
    // Return default categories if none exist
    return ['আচার', 'মিষ্টি', 'খিচুড়ি', 'তরকারি'];
  } catch (error) {
    console.error('Error getting categories:', error);
    return ['আচার', 'মিষ্টি', 'খিচুড়ি', 'তরকারি'];
  }
}

export async function saveCategories(categories) {
  const { data, error } = await supabase
    .from('settings')
    .upsert({ key: 'categories', value: { value: categories } }, { onConflict: 'key' })
    .select()
    .single();
  if (error) {
    console.error('Error saving categories:', error);
    throw error;
  }
  return data;
}

export async function addCategory(categoryName) {
  try {
    const currentCategories = await getCategories();
    if (!currentCategories.includes(categoryName)) {
      const updated = [...currentCategories, categoryName];
      await saveCategories(updated);
      // Reload from database to ensure it was saved correctly
      const saved = await getCategories();
      return saved;
    }
    return currentCategories;
  } catch (error) {
    console.error('Error adding category:', error);
    throw error;
  }
}

export async function deleteCategory(categoryName) {
  try {
    const currentCategories = await getCategories();
    const updated = currentCategories.filter(cat => cat !== categoryName);
    await saveCategories(updated);
    // Reload from database to ensure it was saved correctly
    const saved = await getCategories();
    return saved;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
}

export async function updateCategory(oldName, newName) {
  try {
    const currentCategories = await getCategories();
    const index = currentCategories.indexOf(oldName);
    if (index !== -1) {
      const updated = [...currentCategories];
      updated[index] = newName;
      await saveCategories(updated);
      // Reload from database to ensure it was saved correctly
      const saved = await getCategories();
      return saved;
    }
    return currentCategories;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
}

